import { get } from './client';

/**
 * Health check response from API.
 */
export interface HealthResponse {
  status: 'healthy' | 'degraded' | 'unhealthy';
  version: string;
  timestamp: string;
  components?: {
    database?: { status: string };
    cache?: { status: string };
  };
}

/**
 * Fetch API health status.
 * This endpoint is usually cached briefly (10 seconds).
 */
export async function getHealth(): Promise<HealthResponse> {
  return get<HealthResponse>('/health');
}
